import { ViewportType } from '../../../enums';
import { getECGProjectionPresentation, withECGProjectionPresentation, } from './ecgProjectionPresentation';
import { getECGProjectionSnapshot } from './ecgProjectionSnapshot';
import { ECG_PROJECTION_ID, } from './ECGProjectionTypes';
export { getECGProjectionSnapshot };
export const ecgProjectionAdapter = {
    id: ECG_PROJECTION_ID,
    viewportTypes: [ViewportType.ECG_NEXT],
    getSnapshot: (request) => getECGProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getECGProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withECGProjectionPresentation(snapshot, presentation, options),
};
